'use strict';

const API = require('./API');

class AthomCallbackAPI extends API {

  static SPECIFICATION = require('../assets/specifications/AthomCallbackAPI.json');
  static SPECIFICATION_URL = 'https://callback.athom.com/specification.json';
  static JSDOC_PRIVATE = true;

}

module.exports = AthomCallbackAPI;
